import { render, staticRenderFns } from "./AiAssistant.vue?vue&type=template&id=e631aa8c&scoped=true&"
import script from "./AiAssistant.vue?vue&type=script&lang=js&"
export * from "./AiAssistant.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistant.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AiAssistant.vue?vue&type=style&index=1&id=e631aa8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e631aa8c",
  null
  
)

export default component.exports